"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ActorRdfDereferenceHttpParseBase_1 = require("./ActorRdfDereferenceHttpParseBase");
/**
 * The browser variant of {@link ActorRdfDereferenceHttpParse}.
 */


var ActorRdfDereferenceHttpParse =
/*#__PURE__*/
function (_ActorRdfDereferenceH) {
  _inherits(ActorRdfDereferenceHttpParse, _ActorRdfDereferenceH);

  function ActorRdfDereferenceHttpParse(args) {
    _classCallCheck(this, ActorRdfDereferenceHttpParse);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfDereferenceHttpParse).call(this, args));
  }

  _createClass(ActorRdfDereferenceHttpParse, [{
    key: "getMaxAcceptHeaderLength",
    value: function getMaxAcceptHeaderLength() {
      return this.maxAcceptHeaderLengthBrowser;
    }
  }]);

  return ActorRdfDereferenceHttpParse;
}(ActorRdfDereferenceHttpParseBase_1.ActorRdfDereferenceHttpParseBase);

exports.ActorRdfDereferenceHttpParse = ActorRdfDereferenceHttpParse;